import React from 'react';
import PropTypes from 'prop-types';

function SliderSettingsVertical({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path
        d="M8.39688 20L8.39688 9.52381M8.39688 9.52381C9.84334 9.52381 11.0159 8.35122 11.0159 6.90476C11.0159 5.4583 9.84334 4.28571 8.39688 4.28571C6.95042 4.28571 5.77783 5.4583 5.77783 6.90476C5.77783 8.35122 6.95042 9.52381 8.39688 9.52381ZM15.381 14.7619L15.381 4.28571M15.381 14.7619C16.8275 14.7619 18.0001 15.9345 18.0001 17.381C18.0001 18.8274 16.8275 20 15.381 20C13.9345 20 12.762 18.8274 12.762 17.381C12.762 15.9345 13.9345 14.7619 15.381 14.7619Z"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

SliderSettingsVertical.propTypes = {
  stroke: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  strokeWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

export default SliderSettingsVertical;
